/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * RapidWorks.UserManagement.WebApi | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApprovalRequestListItemDto,
  CreatePermissionRoleInput,
  CreateRoleDeleteApprovalInput,
  CreateRoleMetadataEditApprovalInput,
  CreateRolePermissionApprovalInput,
  CrossUserManagementRolePermissionsResultDto,
  GetApiUserManagementV1RolesParams,
  GetApiUserManagementV1RolesRoleIdPermissionsExportParams,
  ProblemDetails,
  RoleUpdateResultDto,
  UpdatePermissionRoleInput
} from '../model';

import { axiosInstance } from '../../axios-instance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export const getApiUserManagementV1Roles = (
  params?: GetApiUserManagementV1RolesParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/roles`, method: 'GET', params, signal }, options);
};

export const getGetApiUserManagementV1RolesQueryKey = (params?: GetApiUserManagementV1RolesParams) => {
  return [`/api/user-management/v1/roles`, ...(params ? [params] : [])] as const;
};

export const getGetApiUserManagementV1RolesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1Roles>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1RolesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Roles>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1RolesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1Roles>>> = ({ signal }) =>
    getApiUserManagementV1Roles(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1Roles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1RolesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserManagementV1Roles>>>;
export type GetApiUserManagementV1RolesQueryError = unknown;

export function useGetApiUserManagementV1Roles<TData = Awaited<ReturnType<typeof getApiUserManagementV1Roles>>, TError = unknown>(
  params: undefined | GetApiUserManagementV1RolesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Roles>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1Roles>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1Roles>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1Roles<TData = Awaited<ReturnType<typeof getApiUserManagementV1Roles>>, TError = unknown>(
  params?: GetApiUserManagementV1RolesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Roles>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1Roles>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1Roles>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1Roles<TData = Awaited<ReturnType<typeof getApiUserManagementV1Roles>>, TError = unknown>(
  params?: GetApiUserManagementV1RolesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Roles>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1Roles<TData = Awaited<ReturnType<typeof getApiUserManagementV1Roles>>, TError = unknown>(
  params?: GetApiUserManagementV1RolesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Roles>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1RolesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const postApiUserManagementV1Roles = (
  createPermissionRoleInput: CreatePermissionRoleInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/user-management/v1/roles`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createPermissionRoleInput,
      signal
    },
    options
  );
};

export const getPostApiUserManagementV1RolesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1Roles>>,
    TError,
    { data: CreatePermissionRoleInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof postApiUserManagementV1Roles>>, TError, { data: CreatePermissionRoleInput }, TContext> => {
  const mutationKey = ['postApiUserManagementV1Roles'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUserManagementV1Roles>>, { data: CreatePermissionRoleInput }> = (
    props
  ) => {
    const { data } = props ?? {};

    return postApiUserManagementV1Roles(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1RolesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUserManagementV1Roles>>>;
export type PostApiUserManagementV1RolesMutationBody = CreatePermissionRoleInput;
export type PostApiUserManagementV1RolesMutationError = unknown;

export const usePostApiUserManagementV1Roles = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1Roles>>,
      TError,
      { data: CreatePermissionRoleInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof postApiUserManagementV1Roles>>, TError, { data: CreatePermissionRoleInput }, TContext> => {
  return useMutation(getPostApiUserManagementV1RolesMutationOptions(options), queryClient);
};
export const getApiUserManagementV1RolesRoleId = (
  roleId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/roles/${roleId}`, method: 'GET', signal }, options);
};

export const getGetApiUserManagementV1RolesRoleIdQueryKey = (roleId: number) => {
  return [`/api/user-management/v1/roles/${roleId}`] as const;
};

export const getGetApiUserManagementV1RolesRoleIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>,
  TError = unknown
>(
  roleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1RolesRoleIdQueryKey(roleId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>> = ({ signal }) =>
    getApiUserManagementV1RolesRoleId(roleId, requestOptions, signal);

  return { queryKey, queryFn, enabled: roleId !== null && roleId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1RolesRoleIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>>;
export type GetApiUserManagementV1RolesRoleIdQueryError = unknown;

export function useGetApiUserManagementV1RolesRoleId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>,
  TError = unknown
>(
  roleId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1RolesRoleId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>,
  TError = unknown
>(
  roleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1RolesRoleId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>,
  TError = unknown
>(
  roleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1RolesRoleId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>,
  TError = unknown
>(
  roleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1RolesRoleIdQueryOptions(roleId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const putApiUserManagementV1RolesRoleId = (
  roleId: number,
  updatePermissionRoleInput: UpdatePermissionRoleInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<RoleUpdateResultDto>(
    {
      url: `/api/user-management/v1/roles/${roleId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updatePermissionRoleInput,
      signal
    },
    options
  );
};

export const getPutApiUserManagementV1RolesRoleIdMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiUserManagementV1RolesRoleId>>,
    TError,
    { roleId: number; data: UpdatePermissionRoleInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiUserManagementV1RolesRoleId>>,
  TError,
  { roleId: number; data: UpdatePermissionRoleInput },
  TContext
> => {
  const mutationKey = ['putApiUserManagementV1RolesRoleId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiUserManagementV1RolesRoleId>>,
    { roleId: number; data: UpdatePermissionRoleInput }
  > = (props) => {
    const { roleId, data } = props ?? {};

    return putApiUserManagementV1RolesRoleId(roleId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiUserManagementV1RolesRoleIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiUserManagementV1RolesRoleId>>>;
export type PutApiUserManagementV1RolesRoleIdMutationBody = UpdatePermissionRoleInput;
export type PutApiUserManagementV1RolesRoleIdMutationError = ProblemDetails;

export const usePutApiUserManagementV1RolesRoleId = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiUserManagementV1RolesRoleId>>,
      TError,
      { roleId: number; data: UpdatePermissionRoleInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiUserManagementV1RolesRoleId>>,
  TError,
  { roleId: number; data: UpdatePermissionRoleInput },
  TContext
> => {
  return useMutation(getPutApiUserManagementV1RolesRoleIdMutationOptions(options), queryClient);
};
export const getApiUserManagementV1RolesRoleIdDeviations = (
  roleId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/roles/${roleId}/deviations`, method: 'GET', signal }, options);
};

export const getGetApiUserManagementV1RolesRoleIdDeviationsQueryKey = (roleId: number) => {
  return [`/api/user-management/v1/roles/${roleId}/deviations`] as const;
};

export const getGetApiUserManagementV1RolesRoleIdDeviationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>,
  TError = unknown
>(
  roleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1RolesRoleIdDeviationsQueryKey(roleId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>> = ({ signal }) =>
    getApiUserManagementV1RolesRoleIdDeviations(roleId, requestOptions, signal);

  return { queryKey, queryFn, enabled: roleId !== null && roleId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1RolesRoleIdDeviationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>
>;
export type GetApiUserManagementV1RolesRoleIdDeviationsQueryError = unknown;

export function useGetApiUserManagementV1RolesRoleIdDeviations<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>,
  TError = unknown
>(
  roleId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1RolesRoleIdDeviations<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>,
  TError = unknown
>(
  roleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1RolesRoleIdDeviations<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>,
  TError = unknown
>(
  roleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1RolesRoleIdDeviations<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>,
  TError = unknown
>(
  roleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdDeviations>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1RolesRoleIdDeviationsQueryOptions(roleId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getApiUserManagementV1RolesRoleIdPermissions = (
  roleId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CrossUserManagementRolePermissionsResultDto>(
    { url: `/api/user-management/v1/roles/${roleId}/permissions`, method: 'GET', signal },
    options
  );
};

export const getGetApiUserManagementV1RolesRoleIdPermissionsQueryKey = (roleId: number) => {
  return [`/api/user-management/v1/roles/${roleId}/permissions`] as const;
};

export const getGetApiUserManagementV1RolesRoleIdPermissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>,
  TError = ProblemDetails
>(
  roleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1RolesRoleIdPermissionsQueryKey(roleId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>> = ({ signal }) =>
    getApiUserManagementV1RolesRoleIdPermissions(roleId, requestOptions, signal);

  return { queryKey, queryFn, enabled: roleId !== null && roleId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1RolesRoleIdPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>
>;
export type GetApiUserManagementV1RolesRoleIdPermissionsQueryError = ProblemDetails;

export function useGetApiUserManagementV1RolesRoleIdPermissions<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>,
  TError = ProblemDetails
>(
  roleId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1RolesRoleIdPermissions<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>,
  TError = ProblemDetails
>(
  roleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1RolesRoleIdPermissions<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>,
  TError = ProblemDetails
>(
  roleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1RolesRoleIdPermissions<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>,
  TError = ProblemDetails
>(
  roleId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissions>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1RolesRoleIdPermissionsQueryOptions(roleId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getApiUserManagementV1RolesRoleIdPermissionsExport = (
  roleId: number,
  params?: GetApiUserManagementV1RolesRoleIdPermissionsExportParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/roles/${roleId}/permissions/export`, method: 'GET', params, signal }, options);
};

export const getGetApiUserManagementV1RolesRoleIdPermissionsExportQueryKey = (
  roleId: number,
  params?: GetApiUserManagementV1RolesRoleIdPermissionsExportParams
) => {
  return [`/api/user-management/v1/roles/${roleId}/permissions/export`, ...(params ? [params] : [])] as const;
};

export const getGetApiUserManagementV1RolesRoleIdPermissionsExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>,
  TError = unknown
>(
  roleId: number,
  params?: GetApiUserManagementV1RolesRoleIdPermissionsExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1RolesRoleIdPermissionsExportQueryKey(roleId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>> = ({ signal }) =>
    getApiUserManagementV1RolesRoleIdPermissionsExport(roleId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: roleId !== null && roleId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1RolesRoleIdPermissionsExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>
>;
export type GetApiUserManagementV1RolesRoleIdPermissionsExportQueryError = unknown;

export function useGetApiUserManagementV1RolesRoleIdPermissionsExport<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>,
  TError = unknown
>(
  roleId: number,
  params: undefined | GetApiUserManagementV1RolesRoleIdPermissionsExportParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1RolesRoleIdPermissionsExport<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>,
  TError = unknown
>(
  roleId: number,
  params?: GetApiUserManagementV1RolesRoleIdPermissionsExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1RolesRoleIdPermissionsExport<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>,
  TError = unknown
>(
  roleId: number,
  params?: GetApiUserManagementV1RolesRoleIdPermissionsExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1RolesRoleIdPermissionsExport<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>,
  TError = unknown
>(
  roleId: number,
  params?: GetApiUserManagementV1RolesRoleIdPermissionsExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1RolesRoleIdPermissionsExport>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1RolesRoleIdPermissionsExportQueryOptions(roleId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const postApiUserManagementV1RolesRoleIdPermissionsApprovalRequests = (
  roleId: number,
  createRolePermissionApprovalInput: CreateRolePermissionApprovalInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<ApprovalRequestListItemDto>(
    {
      url: `/api/user-management/v1/roles/${roleId}/permissions/approval-requests`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createRolePermissionApprovalInput,
      signal
    },
    options
  );
};

export const getPostApiUserManagementV1RolesRoleIdPermissionsApprovalRequestsMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdPermissionsApprovalRequests>>,
    TError,
    { roleId: number; data: CreateRolePermissionApprovalInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdPermissionsApprovalRequests>>,
  TError,
  { roleId: number; data: CreateRolePermissionApprovalInput },
  TContext
> => {
  const mutationKey = ['postApiUserManagementV1RolesRoleIdPermissionsApprovalRequests'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdPermissionsApprovalRequests>>,
    { roleId: number; data: CreateRolePermissionApprovalInput }
  > = (props) => {
    const { roleId, data } = props ?? {};

    return postApiUserManagementV1RolesRoleIdPermissionsApprovalRequests(roleId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1RolesRoleIdPermissionsApprovalRequestsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdPermissionsApprovalRequests>>
>;
export type PostApiUserManagementV1RolesRoleIdPermissionsApprovalRequestsMutationBody = CreateRolePermissionApprovalInput;
export type PostApiUserManagementV1RolesRoleIdPermissionsApprovalRequestsMutationError = ProblemDetails;

export const usePostApiUserManagementV1RolesRoleIdPermissionsApprovalRequests = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdPermissionsApprovalRequests>>,
      TError,
      { roleId: number; data: CreateRolePermissionApprovalInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdPermissionsApprovalRequests>>,
  TError,
  { roleId: number; data: CreateRolePermissionApprovalInput },
  TContext
> => {
  return useMutation(getPostApiUserManagementV1RolesRoleIdPermissionsApprovalRequestsMutationOptions(options), queryClient);
};
export const postApiUserManagementV1RolesRoleIdEditApprovalRequests = (
  roleId: number,
  createRoleMetadataEditApprovalInput: CreateRoleMetadataEditApprovalInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<ApprovalRequestListItemDto>(
    {
      url: `/api/user-management/v1/roles/${roleId}/edit-approval-requests`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createRoleMetadataEditApprovalInput,
      signal
    },
    options
  );
};

export const getPostApiUserManagementV1RolesRoleIdEditApprovalRequestsMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdEditApprovalRequests>>,
    TError,
    { roleId: number; data: CreateRoleMetadataEditApprovalInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdEditApprovalRequests>>,
  TError,
  { roleId: number; data: CreateRoleMetadataEditApprovalInput },
  TContext
> => {
  const mutationKey = ['postApiUserManagementV1RolesRoleIdEditApprovalRequests'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdEditApprovalRequests>>,
    { roleId: number; data: CreateRoleMetadataEditApprovalInput }
  > = (props) => {
    const { roleId, data } = props ?? {};

    return postApiUserManagementV1RolesRoleIdEditApprovalRequests(roleId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1RolesRoleIdEditApprovalRequestsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdEditApprovalRequests>>
>;
export type PostApiUserManagementV1RolesRoleIdEditApprovalRequestsMutationBody = CreateRoleMetadataEditApprovalInput;
export type PostApiUserManagementV1RolesRoleIdEditApprovalRequestsMutationError = ProblemDetails;

export const usePostApiUserManagementV1RolesRoleIdEditApprovalRequests = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdEditApprovalRequests>>,
      TError,
      { roleId: number; data: CreateRoleMetadataEditApprovalInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdEditApprovalRequests>>,
  TError,
  { roleId: number; data: CreateRoleMetadataEditApprovalInput },
  TContext
> => {
  return useMutation(getPostApiUserManagementV1RolesRoleIdEditApprovalRequestsMutationOptions(options), queryClient);
};
export const postApiUserManagementV1RolesRoleIdDeleteApprovalRequests = (
  roleId: number,
  createRoleDeleteApprovalInput: CreateRoleDeleteApprovalInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<ApprovalRequestListItemDto>(
    {
      url: `/api/user-management/v1/roles/${roleId}/delete-approval-requests`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createRoleDeleteApprovalInput,
      signal
    },
    options
  );
};

export const getPostApiUserManagementV1RolesRoleIdDeleteApprovalRequestsMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdDeleteApprovalRequests>>,
    TError,
    { roleId: number; data: CreateRoleDeleteApprovalInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdDeleteApprovalRequests>>,
  TError,
  { roleId: number; data: CreateRoleDeleteApprovalInput },
  TContext
> => {
  const mutationKey = ['postApiUserManagementV1RolesRoleIdDeleteApprovalRequests'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdDeleteApprovalRequests>>,
    { roleId: number; data: CreateRoleDeleteApprovalInput }
  > = (props) => {
    const { roleId, data } = props ?? {};

    return postApiUserManagementV1RolesRoleIdDeleteApprovalRequests(roleId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1RolesRoleIdDeleteApprovalRequestsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdDeleteApprovalRequests>>
>;
export type PostApiUserManagementV1RolesRoleIdDeleteApprovalRequestsMutationBody = CreateRoleDeleteApprovalInput;
export type PostApiUserManagementV1RolesRoleIdDeleteApprovalRequestsMutationError = ProblemDetails;

export const usePostApiUserManagementV1RolesRoleIdDeleteApprovalRequests = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdDeleteApprovalRequests>>,
      TError,
      { roleId: number; data: CreateRoleDeleteApprovalInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUserManagementV1RolesRoleIdDeleteApprovalRequests>>,
  TError,
  { roleId: number; data: CreateRoleDeleteApprovalInput },
  TContext
> => {
  return useMutation(getPostApiUserManagementV1RolesRoleIdDeleteApprovalRequestsMutationOptions(options), queryClient);
};
